module.exports = __webpack_public_path__ + "static/media/palliatieve-zorg-vrouw-biedt-vrouw-zorg-en-hulp.00fe09d0.jpg";